type TUnauthorizedBody = {
  errors?: Array<{ message?: string }>;
  message?: string;
};

type Handler = () => void;

let unauthorizedHandler: Handler | undefined;
let activityHandler: Handler | undefined;

export const setUnauthorizedHandler = (handler?: Handler) => {
  unauthorizedHandler = handler;
};

export const setActivityHandler = (handler?: Handler) => {
  activityHandler = handler;
};

const isSessionUnauthorized = (body: unknown): boolean => {
  if (!body || typeof body !== 'object') return false;
  const { errors, message } = body as TUnauthorizedBody;
  if (message === 'Inactive user') return true;
  return !!errors?.some((e) => typeof e.message === 'string' && e.message.startsWith('E_UNAUTHORIZED_ACCESS'));
};

export const notifyUnauthorized = (body: unknown) => {
  if (!isSessionUnauthorized(body)) return;
  unauthorizedHandler?.();
};

export const notifyActivity = () => {
  try {
    activityHandler?.();
  } catch (err) {
    console.error(err);
  }
};
